import { render, staticRenderFns } from "./InnerControlledAccordionPanel.vue?vue&type=template&id=2f3d6d5c&"
import script from "./InnerControlledAccordionPanel.vue?vue&type=script&lang=js&"
export * from "./InnerControlledAccordionPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports